import React from "react";
import formatPhone from "../../helpers/formatPhone";
import "./call-to-action.scss";

const Cta = (business) => {
  const customCta = business.websites.filter(
    (site) => site.type === "callToAction"
  );

  if (customCta && customCta.length) {
    return <a href={customCta.url}>{customCta.text}</a>;
  }

  if (business.phoneNumber) {
    return (
      <a href={`tel:${business.phoneNumber}`}>
        Ph: {formatPhone(business.phoneNumber)}
      </a>
    );
  }

  if (business.email) {
    return <a href={`mailto:${business.email}`}>Email us!</a>;
  }
};

const CallToActionLink = ({ className = "", ...business }) => {
  return (
    <div className={`cta-wrapper ${className}`}>
      <Cta {...business} />
    </div>
  );
};

export default CallToActionLink;
